import React, {useCallback, useEffect} from 'react'
import {useQuill} from 'react-quilljs'
import 'quill/dist/quill.snow.css'
import './../style/inbox.scss'

export const InboxQuill = ({
  setQuillText,
  quillText,
  formik,
  templateData,
  emailData,
  isDiscard,
  isDisable,
  forwardMessageBody,
  aiEmailResponse,
}: {
  quillText: string
  setQuillText: any
  formik?: any
  templateData?: any
  emailData?: any
  isDiscard?: any
  isDisable?: boolean
  forwardMessageBody?: any
  aiEmailResponse?: any
}) => {
  console.log(quillText, ' quillText')
  const theme = 'snow'

  const modules = {
    toolbar: false,
  }
  const placeholder = ''

  const formats: any[] = []

  const {quill, quillRef} = useQuill({theme, modules, formats, placeholder, readOnly: isDisable})

  const insertCustomText = useCallback(() => {
    const range = quill?.getSelection()
    quill?.insertText(range!.index, 'Custom text')
    quill?.setSelection(range!.index + 1, 0)
  }, [quill])

  useEffect(() => {
    if (quill && templateData?.body) {
      // quill.root.innerHTML = templateData?.body
      quill.clipboard.dangerouslyPasteHTML(templateData.body)
    }
    if (quill && emailData?.email?.body) {
      quill.root.innerHTML = emailData?.email?.body
    }
    if (quill && forwardMessageBody) {
      quill.root.innerHTML = forwardMessageBody
    }

    if (quill && aiEmailResponse) {
      quill.root.innerHTML = aiEmailResponse
    }
  }, [quill, templateData?.body, emailData?.email?.body, forwardMessageBody, aiEmailResponse])

  useEffect(() => {
    if (quill) {
      quill.on('text-change', () => {
        setQuillText(quill.root.innerHTML)
        formik.setFieldValue('quillText', quill.root.innerHTML)
      })
    }
  }, [quill, insertCustomText, formik, setQuillText, quillText])

  useEffect(() => {
    if (quill && isDiscard) {
      quill.root.innerHTML = ''
      setQuillText('')
      formik.setFieldValue('quillText', '')
    }
  }, [quill, isDiscard]) // eslint-disable-line react-hooks/exhaustive-deps

  console.log(templateData, ' templateData')
  console.log(quillText, ' quillText')
  return (
    <div style={{width: '100%', height: '100%'}}>
      <div ref={quillRef} className='inbox-body p-4 text-dark' />
    </div>
  )
}
